





import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "BaseIconButton",
  components: { BaseIcon },
  props: {
    fontSize: { type: [String, Number], default: 24 },
    color: { type: String },
  },
});
